module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"link":"Подробнее о компании"}}')
  delete Component.options._Ctor
}
